// URLs of the machine view (OpenSpec 137). The worker (src/server/machine-view/path.ts) owns the
// rules; these helpers only build the links that pages show.

const trim = (path: string) => (path.length > 1 ? path.replace(/\/+$/, '') : path) || '/'

/** `/pricing` -> `/pricing.md`, `/` -> `/index.md`. */
export const markdownHref = (path: string): string => {
  const p = trim(path)
  return p === '/' ? '/index.md' : `${p}.md`
}

/** `/pricing` -> `/machine/pricing`, `/` -> `/machine`. */
export const machineHref = (path: string): string => {
  const p = trim(path)
  return p === '/' ? '/machine' : `/machine${p}`
}

/** The page behind a path: `/machine/pricing` -> `/pricing`; any other path is returned as it is. */
export const pageOf = (path: string): string => {
  const p = trim(path)
  if (p === '/machine') return '/'
  return p.startsWith('/machine/') ? p.slice('/machine'.length) : p
}

/**
 * The smooth HUMAN / MACHINE switch (OpenSpec 137): both pages opt in to a cross-document view
 * transition, so Chrome and Safari fade between them (Firefox switches at once). The pill and the
 * page title keep a name on both pages, so they morph instead of fading. Timing follows parallel.ai/ai:
 * 300 ms ease-out. One copy for the HTML pages (`_site` head) and the worker's machine view.
 */
export const VIEW_TRANSITION_CSS =
  '@media (prefers-reduced-motion: no-preference){' +
  '@view-transition{navigation:auto}' +
  '.vt-pill{view-transition-name:view-pill}' +
  'main h1,.vt-title{view-transition-name:page-title}' +
  '::view-transition-group(*){animation-duration:300ms;animation-timing-function:ease-out}' +
  '::view-transition-old(root),::view-transition-new(root){animation-duration:300ms}' +
  '}'
